import { render, staticRenderFns } from "./ShopStoreTakeoutProduct.vue?vue&type=template&id=0ac0f1b5&scoped=true&"
import script from "./ShopStoreTakeoutProduct.vue?vue&type=script&lang=js&"
export * from "./ShopStoreTakeoutProduct.vue?vue&type=script&lang=js&"
import style0 from "./ShopStoreTakeoutProduct.vue?vue&type=style&index=0&id=0ac0f1b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0f1b5",
  null
  
)

export default component.exports